import React, { useEffect, useState } from "react";
import style from "../CommonStyles/commonformstyles.module.scss";

const ServicePackageForm = ({ formData, setFormData, handleNext }) => {
  const [activePlan, setActivePlan] = useState("half");

  // Ensure formData.pricing is initialized
  useEffect(() => {
    if (!formData.pricing?.half || !formData.pricing?.full) {
      setFormData((prev) => ({
        ...prev,
        pricing: {
          half: { hours: "", price: "" },
          full: { hours: "", price: "" },
        },
      }));
    }
  }, [formData, setFormData]);

  const handleInputChange = (e, plan, field) => {
    const { value } = e.target;
    // Allow only non-negative numbers
    if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
      setFormData((prevData) => ({
        ...prevData,
        pricing: {
          ...prevData.pricing,
          [plan]: { ...prevData.pricing[plan], [field]: value },
        },
      }));
    }
  };

  // Calculate total price for a plan
  const calculateTotalPrice = (plan) => {
    const hours = parseFloat(formData.pricing?.[plan]?.hours || 0);
    const pricePerHour = parseFloat(formData.pricing?.[plan]?.price || 0);
    if (
      !isNaN(hours) &&
      !isNaN(pricePerHour) &&
      hours > 0 &&
      pricePerHour > 0
    ) {
      return (hours * pricePerHour).toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
      });
    }
    return "0";
  };

  // Check if all plans have valid data
  const isAllPlansValid = ["half", "full"].every((plan) => {
    const planData = formData.pricing?.[plan];
    return (
      planData &&
      (planData.hours || "").toString().trim() !== "" &&
      (planData.price || "").toString().trim() !== "" &&
      !isNaN(planData.hours) &&
      !isNaN(planData.price) &&
      Number(planData.hours) > 0 &&
      Number(planData.price) > 0
    );
  });

  return (
    <>
      <h2 className={style.dashboardFormContinerHeadingService}>Set Pricing</h2>

      <div className={style.pricingNav}>
        {["half", "full"].map((plan) => (
          <div
            key={plan}
            className={`${style.pricingNavItem} ${
              activePlan === plan ? style.activeNav : ""
            }`}
            onClick={() => setActivePlan(plan)}
          >
            {plan.charAt(0).toUpperCase() + plan.slice(1) + " " + "Day"}
          </div>
        ))}
      </div>

      <div className={style.pricingForm}>
        <div className={style.formField}>
          <label className={style.labels}>Hours you'll spend</label>
          <input
            type="number"
            placeholder={activePlan === "half" ? "4" : "8"}
            value={formData.pricing?.[activePlan]?.hours || ""}
            onChange={(e) => handleInputChange(e, activePlan, "hours")}
            min="0"
            step="0.5"
          />
        </div>

        <div className={style.formField}>
          <label className={style.labels}>Price per hour</label>
          <input
            type="number"
            value={formData.pricing?.[activePlan]?.price || ""}
            onChange={(e) => handleInputChange(e, activePlan, "price")}
            min="0"
            step="100"
            placeholder="0"
          />
        </div>
      </div>

      <div
        style={{
          margin: "10px 0 20px 0",
          fontSize: "0.9rem",
          fontWeight: "bold",
        }}
      >
        {activePlan === "half" ? (
          <p>4 Hour Total Price: {calculateTotalPrice("half")}</p>
        ) : (
          <p>8 Hour Total Price: {calculateTotalPrice("full")}</p>
        )}
      </div>

      <div style={{ margin: "10px 0 20px 0", fontSize: "0.9rem" }}>
        {activePlan === "half" ? (
          <p>
            **Our verified pilots typically price half-day services between
            ₹4,000 and ₹16,000.
          </p>
        ) : (
          <p>
            **To help you price competitively, most verified pilots set full-day
            rates between ₹8,000 and ₹32,000.
          </p>
        )}
      </div>

      <div className={style.formButtonsContainer}>
        <button
          className={style.dashboardFormSaveButtonDown}
          onClick={handleNext}
          disabled={!isAllPlansValid}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default ServicePackageForm;
